import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  CautionIcon,
  SuccessIcon,
  ErrorIcon,
  InfoIcon
} from "../Icons";

const variant = {
  error: "message--error",
  success: "message--success",
  caution: "message--caution",
  disabled: "message--disabled",
  info: "message--info",
  grey: "message--grey",
}

export default class MessageInlineBanner extends Component {
  render() {
    return (
      <div aria-live="polite" className={`message message__inline-banner ${this.props.variant} ${this.props.className}`}>
        <span className="message__icon">
          {(this.props.variant === MessageInlineBanner.variant.error) && (
              <ErrorIcon />
          )}
          {(this.props.variant === MessageInlineBanner.variant.caution) && (
              <CautionIcon />
          )}
          {(this.props.variant === MessageInlineBanner.variant.disabled) && (
              <CautionIcon />
          )}
          {(this.props.variant === MessageInlineBanner.variant.success) && (
              <SuccessIcon />
          )}
          {(this.props.variant === MessageInlineBanner.variant.info) && (
              <InfoIcon />
          )}
          {(this.props.variant === MessageInlineBanner.variant.grey) && (
              <CautionIcon />
          )}
        </span>
        <span className="message-text">{this.props.children}</span>
      </div>
    );
  }
}

MessageInlineBanner.variant = variant;

MessageInlineBanner.propTypes = {
  children: PropTypes.any.isRequired,
  variant: PropTypes.oneOf(Object.values(variant)).isRequired,
  className: PropTypes.string,
};

MessageInlineBanner.defaultProps = {
  variant: MessageInlineBanner.variant.caution,
}
